<template>
  <component
    :is="componentName"
    :primary-key-field="primaryKeyField"
    :fields="fields"
    :view-options="viewOptions"
    :loading="loading"
    :view-query="viewQuery"
    :selection="selection"
    :layout-name="type"
    class="v-ext-layout-options"
    @query="$emit('query', $event);"
    @select="$emit('select', $event);"
    @options="$emit('options', $event);"
  />
</template>

<script>
import Vue from "vue";
import loadExtension from "../../../../helpers/load-extension";
import componentExists from "../../../../helpers/component-exists";
import VExtLayoutOptionsFallback from "./layout-options-fallback.vue";
import VExtLayoutOptionsLoading from "./layout-options-loading.vue";

export default {
  name: "v-ext-layout-options",
  props: {
    type: {
      type: String,
      required: true
    },
    fields: {
      type: Object,
      required: true
    },
    viewOptions: {
      type: Object,
      default: () => ({})
    },
    loading: {
      type: Boolean,
      default: false
    },
    viewQuery: {
      type: Object,
      default: () => ({})
    },
    selection: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    layouts() {
      return this.$store.state.extensions.layouts;
    },
    layout() {
      return this.layouts && this.layouts[this.type];
    },
    componentName() {
      return `layout-options-${this.type}`;
    },
    primaryKeyField() {
      if (!this.fields) return null;

      const primaryKeyField = this.$lodash.find(this.fields, {
        primary_key: true
      });

      return primaryKeyField ? primaryKeyField.field : null;
    }
  },
  watch: {
    type() {
      this.registerLayoutOptions();
    }
  },
  created() {
    this.registerLayoutOptions();
  },
  methods: {
    /**
     * Register the extension as component (if it hasn't been registered before yet)
     */
    registerLayoutOptions() {
      // If component already exists, do nothing
      if (componentExists(this.componentName)) return;

      // If the extension isn't known by the API (e.g. it's not in the store), register it with the
      //   fallback immediately
      if (!this.layout) {
        Vue.component(this.componentName, VExtLayoutOptionsFallback);
        return;
      }

      const filePath = `${this.$api.url}/${this.layout.path.replace(
        "meta.json",
        "options.js"
      )}`;

      Vue.component(this.componentName, () => ({
        component: loadExtension(filePath),
        error: VExtLayoutOptionsFallback,
        loading: VExtLayoutOptionsLoading
      }));
    }
  }
};
</script>
